import {
  WHATSAPP_TICKET_LINK_ENV_CODE_VALUES,
  WHATSAPP_TICKET_LINK_DOMAINS,
  UUID_REGEX,
  type WhatsAppTicketLinkEnv,
} from '@mangelapp/shared';

export interface ParsedWhatsAppTicketRef {
  env: WhatsAppTicketLinkEnv;
  ticketId: string;
}

/**
 * Parse WhatsApp View Ticket encoded ref (envCode_ticketId).
 * Strict: only accepts prd_<uuid> or stg_<uuid>. No plain UUID.
 */
export function parseWhatsAppTicketRef(ref: string): ParsedWhatsAppTicketRef | null {
  if (!ref || typeof ref !== 'string') return null;
  const trimmed = ref.trim();
  for (const code of WHATSAPP_TICKET_LINK_ENV_CODE_VALUES) {
    const prefix = `${code}_`;
    if (!trimmed.startsWith(prefix)) continue;
    const ticketId = trimmed.slice(prefix.length);
    if (UUID_REGEX.test(ticketId)) {
      const env = (code === 'prd' ? 'production' : 'staging') as WhatsAppTicketLinkEnv;
      return { env, ticketId };
    }
    return null;
  }
  return null;
}

/**
 * Build redirect URL for a parsed ref (used by resolver).
 */
export function getWhatsAppTicketRedirectUrl(parsed: ParsedWhatsAppTicketRef): string {
  const base = WHATSAPP_TICKET_LINK_DOMAINS[parsed.env];
  return `${base}/ticket/view/${parsed.ticketId}`;
}
